import React from "react";
import { Collapse, List } from "@mui/material";
import { SpogCompany } from "../../../../legacy/types/SpogCompany";
import { GroupHeader } from "./GroupHeader";
import { CompanyListItem } from "./CompanyListItem";

interface CollapsibleGroupProps {
  groupKey: string;
  icon: React.ReactNode;
  companies: SpogCompany[];
  isExpanded: boolean;
  onToggle: (key: string) => void;
}

export const CollapsibleGroup: React.FC<CollapsibleGroupProps> = ({
  groupKey,
  icon,
  companies,
  isExpanded,
  onToggle,
}) => {
  return (
    <React.Fragment>
      <GroupHeader
        icon={icon}
        title={groupKey}
        count={companies.length}
        isExpanded={isExpanded}
        onToggle={() => onToggle(groupKey)}
      />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {companies.map((company) => (
            <CompanyListItem key={company.hgId} company={company} isNested />
          ))}
        </List>
      </Collapse>
    </React.Fragment>
  );
};
